import Main from './Main.vue'
import Impedimentos from './components/Impedimentos'
// import VisualizarArrematante from './components/VisualizarArrematante'
// import Arrematante from './components/Arrematante'

export default [{
  path: 'impedimentos',
  name: 'impedimentos',
  component: Main,
  children: [
    {path: '/', component: Impedimentos, name: 'impedimentos'}
    // {path: ':id', component: VisualizarArrematante, name: 'impedimentos.visualizar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/impedimentos/routes.js